import React, { Component,useRef } from "react";
import { MaintenanceContext } from "context/maintenanceProvider";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/maintenanceRecord/recordList.scss";
import Swal from "sweetalert2";


export default class RecordList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      repairList: [],
      searchUid: "",
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  async componentDidMount() {
    const data = {
      state: ["finish"],
      pic: null,
      uid: null,
    };
    this.startLoading();
    await this.setDeviceData(data);
    this.stopLoading();
  }

  setDeviceData = async (data) => {
    await this.context.getMaintenance(data);
    this.setState({
      repairList: this.context.maintenanceList.slice(
        this.state.begin,
        this.state.end
      ),
    });
  };

  alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    });
  };

  createSearchMaintenance = () => {
    const { searchUid } = this.state;
    const { maintenanceList } = this.context;
    
    const userOptions = Object.values(maintenanceList?.reduce((acc, user) => {
      if (!acc[user.userId]) {
        acc[user.userId] = {
          key: user.id,
          value: user.userId,
          text: user.userId
        };
      }
      return acc;
    }, {}));
  

    return (
      <div className="search">
        <Form>
          <b>ชื่อผู้ใช้งาน</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={userOptions}
              value={searchUid}
              placeholder="ชื่อผู้ใช้งาน"
              search
              onChange={(e, { value }) => this.setState({ searchUid: value })}
            />
            <Button
              onClick={() => {
                this.setDeviceData({
                  state: ["finish"],
                  pic: null,
                  uid: null,
                });
                this.setState({
                  searchUid: "",
                  searchState: "",
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({
                  state: ["finish"],
                  pic: null,
                  uid: this.state.searchUid,
                });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
          </Form.Group>
        </Form>
      </div>
    );
  };
  
  maintenanceTable = () => {
    const { repairList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Runing Number</Table.HeaderCell>
            <Table.HeaderCell>วันที่และเวลา</Table.HeaderCell>
            <Table.HeaderCell>ชื่อผู้ใช้งาน</Table.HeaderCell>
            <Table.HeaderCell>ชื่อผู้รับผิดชอบ</Table.HeaderCell>
            <Table.HeaderCell>สถานะแจ้งซ่อม</Table.HeaderCell>
            <Table.HeaderCell>แสดงสถานะ</Table.HeaderCell>
            {/* <Table.HeaderCell>EXPORT</Table.HeaderCell> */}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {repairList?.map((order) => (
            <Table.Row key={order.id}>
              <Table.Cell>{order.documentNo}</Table.Cell>
              <Table.Cell>{order.createAt}</Table.Cell>
              <Table.Cell>{order.userId}</Table.Cell>
              <Table.Cell>{order.engineerName}</Table.Cell>
              <Table.Cell>
                {order.isReturn === 0 ? "ปกติ" : "Rejected"}
              </Table.Cell>
              <Table.Cell>
                <Button href={`/record/${order.documentNo}`} color="blue">
                  <Icon name="list alternate outline" />
                  รายละเอียด
                </Button>
              </Table.Cell>
              {/* <Table.Cell>
                <Button
                  // color="yellow"
                  button color="yellow" onClick={() => this.printPDF()}
                >
                  PDF
                </Button>
              </Table.Cell> */}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { maintenanceList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      repairList: [...maintenanceList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize } = this.state;

    return (
      <div className="recordList">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="maintenanceRecord" />
        <Navigation />

        <div className="recordList-content">
          <h2>ประวัติการซ่อม</h2>
          <hr />

          <div className="recordList-content-search">
            {this.createSearchMaintenance()}
          </div>

          <div className="recordList-content-maintenance">
            {this.maintenanceTable()}
          </div>

          <div className="recordList-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.maintenanceList.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

RecordList.contextType = MaintenanceContext;
